import React from 'react';
import PropTypes from 'prop-types';
import getAngularModule from 'App/babel/angularHelpers/getAngularModule';
import InactiveLabel from 'Components/Misc/InactiveLabel';
import { Tooltip } from '@upsales/components';
import { isAvailable, Feature } from 'App/services/FeatureHelperStandalone';
import { leadStatus as LeadStatus } from 'App/babel/components/LegacyReactTemplates';

export default class NameExisting extends React.Component {
	constructor(props) {
		super(props);

		const t = Tools.$translate;

		this.lang = {
			city: t('address.city')
		};
	}

	getAddress() {
		const addressPrio = ['Visit', 'Mail', 'Invoice'];
		const groupedAddresses = _.groupBy(this.props.account.addresses, 'type');

		for (let i = 0; i < addressPrio.length; i++) {
			if (
				groupedAddresses[addressPrio[i]] &&
				groupedAddresses[addressPrio[i]].length &&
				groupedAddresses[addressPrio[i]][0].city
			) {
				return groupedAddresses[addressPrio[i]][0];
			}
		}

		return null;
	}

	getSubtitle() {
		const address = this.getAddress();

		const flag =
			address && address.country ? (
				<b className={'icon flag-icon flag-icon-' + address.country.toLowerCase()} />
			) : null;
		const addressSpan = address ? (
			<span style={{ verticalAlign: 'middle' }}>
				{flag}{' '}
				<Tooltip title={this.lang.city} position="top" key={'city' + this.props.account.id}>
					<span>{address.city}</span>
				</Tooltip>
			</span>
		) : null;

		const history = (
			<LeadStatus
				style={{ marginRight: '10px' }}
				theKey={this.props.account.id}
				tools={Tools}
				activity={this.props.account.hasActivity}
				activityOld={this.props.account.hadActivity}
				appointment={this.props.account.hasAppointment}
				appointmentOld={this.props.account.hadAppointment}
				opportunity={this.props.account.hasOpportunity}
				opportunityOld={this.props.account.hadOpportunity}
				order={this.props.account.hasOrder}
				orderOld={this.props.account.hadOrder}
			/>
		);
		return (
			<span className="subtitle">
				{history} {addressSpan}
			</span>
		);
	}

	editAccount = event => {
		const $upModal = getAngularModule('$upModal');
		$upModal.open('editAccount', { account: this.props.account }, event);
	};

	render() {
		const subtitle = this.getSubtitle();
		const showInactiveLabel = isAvailable(Feature.INACTIVE_COMPANIES);
		const account = this.props.account;

		const Component = !this.props.createNewAccountRow ? 'div' : 'td';

		return (
			<Component
				className={`DataSourceColumn name-existing ${this.props.field.className} ${
					!this.props.createNewAccountRow ? 'align-items-center' : ''
				}`}
			>
				<div>
					<span className="row-text">{account.name}</span>
					{subtitle}
				</div>
				{showInactiveLabel && !account.active ? (
					<div>
						<InactiveLabel onClick={this.editAccount} />
					</div>
				) : null}
			</Component>
		);
	}
}

NameExisting.propTypes = {
	account: PropTypes.object,
	field: PropTypes.object,
	createNewAccountRow: PropTypes.bool
};
